// Per-district turnout board — composes the visualisation that
// readers see under the "By district" heading on /turnout and on
// the homepage (polls_open, results_pending, counting variants).
//
// Current viz: horizontal grouped bars (2026 vs 2022 per district).
// The legacy cube grid (TurnoutCubeGrid + TurnoutShareCard) is
// kept in the codebase as a fallback option — to swap back, mount
// <TurnoutCubeGrid /> here instead of <TurnoutAltBars />.
//
// .cube-grid-shell gives the section the same width envelope as the
// .live-band above (max-width 1500, centered, horizontal padding).
// Necessary when this section lives inside .page-main--full on the
// polls_open homepage — without it the chart would default to the
// outer grid width and not align with the band's content edges.

import TurnoutAltBars from './TurnoutAltBars';
import './TurnoutCubeGrid.css';

export default function TurnoutCubeSection() {
  return (
    <div className="cube-grid-shell">
      <TurnoutAltBars />
    </div>
  );
}
